import { useState, ReactNode, ReactElement, useEffect } from "react";
import { defaultLanguageContext, languageContext } from "../contexts/languageContext";
import i18n from "../i18n";


type LanguageProviderProps = { children: ReactNode };


export function LanguageProvider(props: LanguageProviderProps): ReactElement {
    const [language, setLanguage] = useState(defaultLanguageContext.language);

    useEffect(
        () => {
            i18n.changeLanguage(language);
        },
        [language]
    );

    defaultLanguageContext.language = language;
    defaultLanguageContext.setLanguage = setLanguage;

    return <languageContext.Provider value={defaultLanguageContext}>{props.children}</languageContext.Provider>;
}
